export default __webpack_public_path__ + "img/joined-event-reward-aefe8ec090690c4153d2f59160d5ca39.png";